"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getStyles = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _react = require("@fluentui/react");

var _TextField = require("@fluentui/react/lib/components/TextField/TextField.styles");

var getStyles = function getStyles(props) {
  var theme = props.theme;
  var palette = theme.palette;
  var baseStyles = (0, _TextField.getStyles)(props);
  var underlineBorder = {
    borderTop: '1px solid transparent',
    borderLeft: '1px solid transparent',
    borderRight: '1px solid transparent'
  };
  baseStyles.fieldGroup = (0, _react.mergeStyles)(baseStyles.fieldGroup, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, underlineBorder), {}, {
    selectors: {
      '&:hover': underlineBorder,
      '&:focus': underlineBorder,
      '&:active': underlineBorder
    },
    color: palette.themePrimary
  }));
  return baseStyles;
};

exports.getStyles = getStyles;